import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState } from "react";
import { toast } from "sonner";

export const useLoadDashboard = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{
    upcomingExplorations: boolean;
    attendance: boolean;
  }>({ upcomingExplorations: false, attendance: false });

  const loadUpcomingExplorations = async (
    setUpcomingExplorations: (data: any) => void,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, upcomingExplorations: true }));
      const response = await api(
        "/dashboard/teacher/upcoming-explorations",
        { method: "GET" },
        dispatch,
      );
      setUpcomingExplorations({
        data: response.data,
        teachers: response.teachers,
      });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, upcomingExplorations: false }));
    }
  };

  const loadAttendance = async (setAttendance: (data: any) => void) => {
    try {
      setLoading((prev) => ({ ...prev, attendance: true }));
      const response = await api(
        "/dashboard/teacher/attendance",
        { method: "GET" },
        dispatch,
      );
      setAttendance(response.data);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, attendance: false }));
    }
  };

  return { loadUpcomingExplorations, loadAttendance, loading };
};
